import { render, staticRenderFns } from "./relateNoDialog.vue?vue&type=template&id=31e4fd36&scoped=true"
import script from "./relateNoDialog.vue?vue&type=script&lang=js"
export * from "./relateNoDialog.vue?vue&type=script&lang=js"
import style0 from "./relateNoDialog.vue?vue&type=style&index=0&id=31e4fd36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e4fd36",
  null
  
)

export default component.exports